import { render, staticRenderFns } from "./OrdonnanceForm.vue?vue&type=template&id=19b39194&"
import script from "./OrdonnanceForm.vue?vue&type=script&lang=js&"
export * from "./OrdonnanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports